export class CardIconModel {
    constructor(
        public texto: string,
        public icon: any,
        public clickFunc: any) { }
}
